import React from 'react'
import {
  number
} from 'prop-types'
import circle from '../../assets/icons/circle.svg'
import circleDisabled from '../../assets/icons/circle_disabled.svg'

const Stewardship = props => {
  const printCircles = stewardNumber => {
    const stewCircles = []
    const max = props.max ? props.max: 5
    for(let i = 0; i < max; i++) {
      if(i < stewardNumber) {
        stewCircles.push((<img className='w15' src={circle} alt='circle' key={i}/>))
      } else {
        stewCircles.push((<img className='w15' src={circleDisabled} alt='circle disabled' key={i}/>))
      }
    }
    return stewCircles
  }
  return(
    <div className='df'>
      {printCircles(props.count)}
    </div>
  )
}

export default Stewardship

Stewardship.propTypes = {
  count: number.isRequired,
  max: number
}